import { WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {
	ISearchOrgUserItem,
	setSearchOrgUsersList,
} from 'src/actions/quickModeOrgUserRegisterIniUser';
import QuickModeOrgUserRegisterTreeDetail from '../components/QuickModeOrgUserRegisterTreeDetail';
import { IRootState } from '../reducers';
import ScenarioFactory from '../scenario/QuickModeOrgUserRegisterUserListFactory';

const styles = (theme: Theme) =>
	createStyles({
		content: {
			margin: 'auto',
		},
		root: {
			margin: '0 auto',
			padding: 0,
			wordBreak: 'break-all',
		},
	});
interface IMyProps {
	orgID: string;
}

interface IState {
	open: boolean;
}

/**
 * QuickModeOrgUserRegisterTreeMain
 */
class QuickModeOrgUserRegisterTreeMain extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			open: false,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		const orgID = this.props.orgID;
		this.props.fetchQuickModeDataTree(orgID, this.props.token);
	}

	public render() {
		const { classes, searchOrgUserItemArry } = this.props;

		return (
			<div className={classes.root}>
				<Grid container={true}>
					<Grid item={true} xs={true}>
						<div className={classes.content}>
							{searchOrgUserItemArry &&
								searchOrgUserItemArry.length !== 0 &&
								(searchOrgUserItemArry as ISearchOrgUserItem[]).map(
									(org, i) => (
										<QuickModeOrgUserRegisterTreeDetail
											key={i}
											searchOrgUserItemArry={org}
										/>
									)
								)}
						</div>
					</Grid>
				</Grid>
			</div>
		);
	}
}

const mapStateToProps = (state: IRootState) => ({
	searchOrgUserItemArry:
		state.quickModeOrgUserRegisterTreeObj.searchOrgUserItemArry,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchQuickModeDataTree: (orgID: string, token: string) => {
		const s = ScenarioFactory.createFetchQuickModeOrgUserList(
			dispatch,
			token
		);
		s.run(orgID);
	},
	setSearchOrgUsersList: (searchOrgUserItemArry: ISearchOrgUserItem[]) =>
		dispatch(setSearchOrgUsersList({ searchOrgUserItemArry })),
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IMyProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeOrgUserRegisterTreeMain);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeOrgUserRegisterTreeMain.tsx